import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, isRef as _isRef, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-a618dc64"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "title" }
const _hoisted_2 = { class: "dialog_list" }
const _hoisted_3 = { class: "dialog_list" }
const _hoisted_4 = { class: "dialog_list" }
const _hoisted_5 = { class: "dialog_list" }
const _hoisted_6 = { class: "dialog_list" }
const _hoisted_7 = { class: "dialog_list" }
const _hoisted_8 = { class: "dialog_list batch_download" }
const _hoisted_9 = ["innerHTML"]
const _hoisted_10 = { class: "dialog_list" }
const _hoisted_11 = { class: "dialog_list" }
const _hoisted_12 = { class: "dialog_list" }
const _hoisted_13 = { class: "dialog_list" }
const _hoisted_14 = { class: "dialog_list" }

import DialogBase from '@/components/molecules/DialogBase'
import i18n from '@/plugins/i18n'
import { useStore } from 'vuex'
import { UserPermissions } from '@/@types/typescript-axios'
import { computed, withDefaults } from 'vue'

type PropsType = {
  modelValue: boolean
}


export default /*#__PURE__*/_defineComponent({
  __name: 'UserPermissionsDialog',
  props: {
    modelValue: { type: Boolean, default: false }
  },
  emits: ["update:modelValue"],
  setup(__props: any, { emit }: { emit: ({
  (e: 'update:modelValue', value: boolean): void
}), expose: any, slots: any, attrs: any }) {

const props = __props as { modelValue: boolean };

const store = useStore()





const permissions = computed(() => store.getters['auth/permissions'])
const isTLT = computed(() => store.getters['app/isTLT'])

const displayFlag = computed({
  get: () => props.modelValue,
  set: (newVal) => {
    emit('update:modelValue', newVal)
  },
})

/**
 * @return {Object} 各機能の「使用可・不可」のテキスト
 */
const permissionLabels = computed<UserPermissions>(() => {
  const labels: { [key: string]: string } = {}
  Object.keys(permissions.value).forEach((key) => {
    labels[key] = formatBoolean(permissions.value[key])
  })
  return labels
})
const close = () => {
  displayFlag.value = false
}

/**
 * @param {boolean} b true or false
 * @return {string} formatされた文字列
 */
const formatBoolean = (b: boolean): string => {
  return b
    ? i18n.global.t('user_permissions_dialog.available')
    : i18n.global.t('user_permissions_dialog.not_available')
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(DialogBase), {
    modelValue: _unref(displayFlag),
    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (_isRef(displayFlag) ? (displayFlag).value = $event : null)),
    useCancelBtn: false,
    onApprove: close
  }, {
    title: _withCtx(() => [
      _createElementVNode("h1", _hoisted_1, _toDisplayString(_ctx.$t('user_permissions_dialog.check_privileges')), 1)
    ]),
    body: _withCtx(() => [
      _createElementVNode("div", null, [
        _createElementVNode("dl", _hoisted_2, [
          _createElementVNode("dt", null, _toDisplayString(_ctx.$t('user_permissions_dialog.live_control')), 1),
          _createElementVNode("dd", {
            class: _normalizeClass({ can_use: _unref(permissions).live }),
            "data-test": "permissions-live"
          }, _toDisplayString(_unref(permissionLabels).live), 3)
        ]),
        _createElementVNode("dl", _hoisted_3, [
          _createElementVNode("dt", null, _toDisplayString(_ctx.$t('user_permissions_dialog.view_past_videos')), 1),
          _createElementVNode("dd", {
            class: _normalizeClass({ can_use: _unref(permissions).archive }),
            "data-test": "permissions-archive"
          }, _toDisplayString(_unref(permissionLabels).archive), 3)
        ]),
        _createElementVNode("dl", _hoisted_4, [
          _createElementVNode("dt", null, _toDisplayString(_ctx.$t('user_permissions_dialog.ptz_control')), 1),
          _createElementVNode("dd", {
            class: _normalizeClass({ can_use: _unref(permissions).ptz }),
            "data-test": "permissions-ptz"
          }, _toDisplayString(_unref(permissionLabels).ptz), 3)
        ]),
        _createElementVNode("dl", _hoisted_5, [
          _createElementVNode("dt", null, _toDisplayString(_ctx.$t('user_permissions_dialog.change_password')), 1),
          _createElementVNode("dd", {
            class: _normalizeClass({ can_use: _unref(permissions).modPassword }),
            "data-test": "permissions-modPassword"
          }, _toDisplayString(_unref(permissionLabels).modPassword), 3)
        ]),
        _createElementVNode("dl", _hoisted_6, [
          _createElementVNode("dt", null, _toDisplayString(_ctx.$t('user_permissions_dialog.device_auth_options')), 1),
          _createElementVNode("dd", {
            class: _normalizeClass({ can_use: _unref(permissions).modDevauth }),
            "data-test": "permissions-modDevauth"
          }, _toDisplayString(_unref(permissionLabels).modDevauth), 3)
        ]),
        _createElementVNode("dl", _hoisted_7, [
          _createElementVNode("dt", null, _toDisplayString(_ctx.$t('user_permissions_dialog.heatmap')), 1),
          _createElementVNode("dd", null, [
            _createElementVNode("span", {
              class: _normalizeClass({ can_use: _unref(permissions).heatmap }),
              "data-test": "permissions-heatmap"
            }, _toDisplayString(_unref(permissionLabels).heatmap), 3)
          ])
        ]),
        _createElementVNode("dl", _hoisted_8, [
          _createElementVNode("dt", {
            innerHTML: _ctx.$t('user_permissions_dialog.batch_download')
          }, null, 8, _hoisted_9),
          _createElementVNode("dd", {
            class: _normalizeClass({ can_use: _unref(permissions).batchDownload }),
            "data-test": "permissions-batchDownload"
          }, _toDisplayString(_unref(permissionLabels).batchDownload), 3)
        ]),
        _createElementVNode("dl", _hoisted_10, [
          _createElementVNode("dt", null, _toDisplayString(_ctx.$t('user_permissions_dialog.people_count')), 1),
          _createElementVNode("dd", null, [
            _createElementVNode("span", {
              class: _normalizeClass({ can_use: _unref(permissions).analytics }),
              "data-test": "permissions-analytics"
            }, _toDisplayString(_unref(permissionLabels).analytics), 3)
          ])
        ]),
        _createElementVNode("dl", _hoisted_11, [
          _createElementVNode("dt", null, _toDisplayString(_ctx.$t('user_permissions_dialog.motion_detect_area_setting')), 1),
          _createElementVNode("dd", null, [
            _createElementVNode("span", {
              class: _normalizeClass({ can_use: _unref(permissions).configMotion }),
              "data-test": "permissions-configMotion"
            }, _toDisplayString(_unref(permissionLabels).configMotion), 3)
          ])
        ]),
        (_unref(isTLT))
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
              _createElementVNode("dl", _hoisted_12, [
                _createElementVNode("dt", null, _toDisplayString(_ctx.$t('user_permissions_dialog.enter_alert_setting')), 1),
                _createElementVNode("dd", null, [
                  _createElementVNode("span", {
                    class: _normalizeClass({ can_use: _unref(permissions).configEnterAlert }),
                    "data-test": "permissions-configEnterAlert"
                  }, _toDisplayString(_unref(permissionLabels).configEnterAlert), 3)
                ])
              ]),
              _createElementVNode("dl", _hoisted_13, [
                _createElementVNode("dt", null, _toDisplayString(_ctx.$t('user_permissions_dialog.person_tracking_setting')), 1),
                _createElementVNode("dd", null, [
                  _createElementVNode("span", {
                    class: _normalizeClass({ can_use: _unref(permissions).configPersonTracking }),
                    "data-test": "permissions-configPersonTracking"
                  }, _toDisplayString(_unref(permissionLabels).configPersonTracking), 3)
                ])
              ]),
              _createElementVNode("dl", _hoisted_14, [
                _createElementVNode("dt", null, _toDisplayString(_ctx.$t('user_permissions_dialog.operation_analysis_setting')), 1),
                _createElementVNode("dd", null, [
                  _createElementVNode("span", {
                    class: _normalizeClass({ can_use: _unref(permissions).configOperationAnalysis }),
                    "data-test": "permissions-configOperationAnalysis"
                  }, _toDisplayString(_unref(permissionLabels).configOperationAnalysis), 3)
                ])
              ])
            ], 64))
          : _createCommentVNode("", true)
      ])
    ]),
    _: 1
  }, 8, ["modelValue"]))
}
}

})